<template>
  <div>
    <SearchBarWidget @search="getList" @addForm="handleAdd" />

    <el-table
      :data="tableData"
      style="width: 100%"
      :row-class-name="tableRowClassName"
    >
      <el-table-column prop="name" label="姓名" align="center">
      </el-table-column>
      <el-table-column prop="mobile" label="手机号/工号" align="center">
      </el-table-column>
      <el-table-column prop="noticeTypeName" label="通知方式" align="center">
      </el-table-column>
      <el-table-column prop="contactInfo" label="联系信息" align="center">
      </el-table-column>
      <el-table-column label="启用/禁用" align="center">
        <template slot-scope="scope">
          <div>
            <el-switch
              v-model="scope.row.isFlag"
              inactive-color="#ff4949"
              active-color="#13ce66"
              @change="handleSwitchChange(scope.row)"
            >
            </el-switch>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="120" align="center">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            style="margin: 0 5px 0 0"
            @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="text"
            style="margin: 0 0 0 5px"
            @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 新增/编辑 -->
    <editeNotifiaction ref="editeNotifiaction" @refresh="getList" />
    <!-- 分页 -->
    <Pagination
      ref="Pagination"
      @handleCurrentChange="handleCurrentChange"
      @handleSizeChange="handleSizeChange"
    />
  </div>
</template>
<script>
import SearchBarWidget from './searchBarWidget';
import Pagination from '@/components/Pagination2'; // 分页
import editeNotifiaction from './editeNotifiaction';
import {
  getNoticePersonPageApi,
  noticeDeleteApi,
  editNoticeApi,
} from '@/api/notice';

export default {
  components: { SearchBarWidget, editeNotifiaction, Pagination },
  props: {
    houseId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      paginObj: {
        pageIndex: 1,
        pageSize: 20,
      },
      listLoading: false,
      tableData: [],
    };
  },
  watch: {
    houseId(val) {
      if (!val) return;
      this.getList();
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 列表样式
    tableRowClassName({ rowIndex }) {
      if (rowIndex === 1) {
        return 'warning-row';
      } else if (rowIndex === 3) {
        return 'success-row';
      }
      return '';
    },
    // 获取数据
    getList(obj = {}) {
      try {
        this.listLoading = true;
        getNoticePersonPageApi({
          personType: 4,
          houseId: this.houseId,
          pageSize: this.paginObj.pageSize,
          pageIndex: this.paginObj.pageIndex,
          ...obj,
        }).then((res) => {
          // console.log('通知数据', res);
          let dataList = res.data.dataList;
          if (dataList && dataList.length) {
            this.tableData = dataList.map((item) => {
              item.isFlag = item.isFlag ? true : false;
              return item;
            });
          } else {
            this.tableData = [];
          }
          //   this.pageIndex = res.data.pageIndex;
          //   this.pageSize = res.data.pageSize;
          this.listLoading = false;
          this.$refs.Pagination.pageSize = res.data.pageSize;
          this.$refs.Pagination.pageIndex = res.data.pageIndex;
          this.$refs.Pagination.totalCount = res.data.totalCount;
        });
      } catch (e) {
        window.console.log(e);
      }
    },
    // 启用/禁用
    handleSwitchChange(row) {
      // console.log(row);
      this.changeStatus(row);
    },
    // 编辑
    async changeStatus({ id, name, mobile, noticeType, contactInfo, isFlag }) {
      try {
        let res = await editNoticeApi({
          id,
          name,
          mobile,
          noticeType,
          contactInfo,
          isFlag: isFlag ? 1 : 0, // 取反
        });
        if (res.code == 200) {
          if (isFlag == 0) {
            this.$message.warning('禁用');
          } else {
            this.$message.success('启用');
          }
          this.getList();
        } else {
          this.$message.warning('操作失败');
        }
      } catch (error) {
        this.$message.warning('操作失败');
      }
    },
    // 页面变化
    handleCurrentChange(obj) {
      this.paginObj.pageIndex = obj.pageIndex;
      this.getList();
    },
    // 分页改变页面数据
    handleSizeChange(obj) {
      this.paginObj.pageIndex = 1;
      this.paginObj.pageSize = obj.pageSize;
      this.getList();
    },
    // 新增
    handleAdd() {
      this.$refs.editeNotifiaction.houseId = this.houseId;
      this.$refs.editeNotifiaction.personType = 4;
      this.$refs.editeNotifiaction.title = '新增财务驳回通知';
      this.$refs.editeNotifiaction.dialogFormVisible = true;
    },
    // 编辑
    handleEdit({ id, name, mobile, noticeType, contactInfo, isFlag }) {
      this.$refs.editeNotifiaction.editForm = {
        id,
        name,
        mobile,
        noticeType,
        contactInfo,
        isFlag,
      };
      this.$refs.editeNotifiaction.title = '编辑财务驳回通知';
      this.$refs.editeNotifiaction.dialogFormVisible = true;
    },
    // 删除
    handleDelete({ id }) {
      this.$confirm('确认删除该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          noticeDeleteApi(JSON.stringify(id)).then((res) => {
            if (res.code == 200) {
              this.$message.success('删除成功');
              this.paginObj.pageIndex = 1;
              this.getList();
            } else {
              this.$message.warning('删除失败');
            }
          });
        })
        .catch((error) => {
          console.log(error);
          this.$message.warning('删除失败');
        });
    },
  },
};
</script>
